export default {
  simulation: {
    header: 'Symulacja',
    secondsPerCalculationStepLabel: 'Rozdzielczość',
    secondsPerCalculationStepDescription: 'Symulowany czas pomiędzy dwoma kolejnymi krokami obliczeniowymi',
    factorOnCBetaLabel: 'Czynnik C-Beta',
    factorOnCBetaDescription: 'Dostosuj współczynnik przenoszenia węgla',
    factorOnCDiffCoeffLabel: 'Czynnik na współczynnik C-Diff-Coeff',
    factorOnCDiffCoeffDescription: 'Dostosuj współczynnik dyfuzji węgla',
    timeoutSeconds: 'Maksymalny czas symulacji',
  },
  lowPressureCarburizingOnly: {
    header: 'Tylko nawęglanie niskociśnieniowe',
    maxCInCementiteLabel: 'Max C w Cementite',
    maxCInCementiteDescription: 'Górna granica histerezy automatycznego doładowania',
    cBelowCarbidelimitLabel: 'C poniżej granicy węglikowej',
    cBelowCarbidelimitDescription: 'Dolna granica histerezy automatycznego doładowania',
  },
  showComponentSelectionWhenLoadingCheckbox: 'Pokaż wybór komponentów podczas ładowania',
};
